module.exports = __webpack_public_path__ + "img/img-2.72beffe2.jpg";